import { resources } from "@constants/hardcoded-strings";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { SelectOption } from "@idw-types/common";
import { ScoreStatusType } from "@idw-types/data/rp-service-configuration/scores/score-status-type";
import { ScoreValueProperty } from "@idw-types/data/rp-service-configuration/scores/score-value-property";
import { ScoreStatusTypeMap } from "@idw-types/data/rp-service-configuration/scores/score-status-map";
import { useMemo } from "react";
import { AssertionScoreModifierTableDataRow } from "../assertion-scores-tab-container/assertion-score-modifiers-table-container/assertion-score-modifiers-table-container";
import { TrustScoreModifierTableDataRow } from "../trust-score-tab-container/trust-score-modifiers-table-container/trust-score-modifiers-table-container";
import styles from "./score-table-dynamic-cell.less";
import { getScoreOptions, hasScoreStatus } from "@utils/scores/score-util";

type ScoreTableDynamicCellProps = {
    isDisabled: boolean;
    data: TrustScoreModifierTableDataRow | AssertionScoreModifierTableDataRow;
    rowIndex: number;
    id: ScoreStatusType;
    label: string;
    propertyName: ScoreValueProperty;
    assertionStatusMap: ScoreStatusTypeMap;
    handleAssertionScoreValueChange: (option: SelectOption, index: number, propertyName: ScoreValueProperty) => void;
}

export const ScoreTableDynamicCell = (props: ScoreTableDynamicCellProps) => {
    const {
        isDisabled,
        data,
        rowIndex,
        id,
        propertyName,
        label,
        assertionStatusMap,
        handleAssertionScoreValueChange
    } = props;

    const assertionStatusIDs = data.assertionStatusIDs;
    const value = data[propertyName];
    const shouldShowSelectInput = hasScoreStatus(
        id,
        assertionStatusMap,
        assertionStatusIDs
    );

    const options = getScoreOptions(id, assertionStatusMap);

    const selectedScore = useMemo(() => {
        if (value) {
            const option = options.find((option) => option.value === value);
            if (option) {
                return option;
            }
        }
        return null;
    }, [options, id]);

    const handleChange = (option: SelectOption) => {
        let optionSelected = { value: "", label: "" };
        if (option) {
            optionSelected = option;
        }

        handleAssertionScoreValueChange(
            optionSelected,
            rowIndex,
            propertyName
        );
    };

    return (
        <span>
            {shouldShowSelectInput ? (
                <SelectFormGroup
                    className={styles.scoreSelectFormGroup}
                    controlId={`${data.id}-${id}-select-input`}
                    automationId={`${data.id}-${id}-select-input`}
                    ariaLabel={label}
                    disabled={isDisabled}
                    isClearable={true}
                    isRequired={false}
                    isSearchable={true}
                    layout={LayoutTypes.ROW}
                    labelWidth={LabelWidthTypes.SMALL}
                    onChange={handleChange}
                    options={options}
                    selectedOption={selectedScore}
                />
            ) : (
                <span>{resources.common.notAvailable}</span>
            )}
        </span>
    );
}